const GOOGLE_API_KEY = "AIzaSyCX_9T83vz3JPCL7gkBXqh11qSo--rBcNk";

export const YOUTUBE_VIDEOS_API = 'https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key=' + GOOGLE_API_KEY;
export const YOUTUBE_SEARCH_API = "https://corsproxy.io/?https://clients1.google.com/complete/search?client=firefox&ds=yt&q=";
export const OFFSET_LIVE_CHAT = 25;